import { useAtom } from '@reatom/npm-react'

import { TradingControlsQuote } from '@root/features/trade/trading-controls/ui/common'

import type { Pair } from '@root/entities/pair'
import type { MarketBuyControlsModel } from '@root/features/trade/trading-controls/atoms/common'

type Props = {
  pair: Pair.PairMinimal
  model: MarketBuyControlsModel
}

export const InstantTradeBuyQuote: React.FC<Props> = ({ pair, model }) => {
  const [quoteState] = useAtom(model.quoteModel.quoteStateAtom)

  return (
    <TradingControlsQuote
      swapDirection="buy"
      pair={pair}
      quoteState={quoteState}
    />
  )
}
